module.exports = __webpack_public_path__ + "static/media/google-reviews-logo.c01e206d.png";